import React, { Component } from 'react';

class CardIcon extends Component {
  render() {
    return (
      <svg
        width="32"
        height="23"
        viewBox="0 0 32 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={this.props.style}
      >
        <path
          d="M29.7143 0H2.28571C1.67951 0 1.09812 0.242321 0.66947 0.673654C0.240816 1.10499 0 1.69 0 2.3V20.7C0 21.31 0.240816 21.895 0.66947 22.3263C1.09812 22.7577 1.67951 23 2.28571 23H29.7143C30.3205 23 30.9019 22.7577 31.3305 22.3263C31.7592 21.895 32 21.31 32 20.7V2.3C32 1.69 31.7592 1.10499 31.3305 0.673654C30.9019 0.242321 30.3205 0 29.7143 0ZM29.7143 2.3V5.75H2.28571V2.3H29.7143ZM29.7143 20.7H2.28571V8.05H29.7143V20.7ZM27.4286 17.25C27.4286 17.555 27.3082 17.8475 27.0938 18.0632C26.8795 18.2788 26.5888 18.4 26.2857 18.4H21.7143C21.4112 18.4 21.1205 18.2788 20.9062 18.0632C20.6918 17.8475 20.5714 17.555 20.5714 17.25C20.5714 16.945 20.6918 16.6525 20.9062 16.4368C21.1205 16.2212 21.4112 16.1 21.7143 16.1H26.2857C26.5888 16.1 26.8795 16.2212 27.0938 16.4368C27.3082 16.6525 27.4286 16.945 27.4286 17.25ZM18.2857 17.25C18.2857 17.555 18.1653 17.8475 17.951 18.0632C17.7367 18.2788 17.446 18.4 17.1429 18.4H14.8571C14.554 18.4 14.2633 18.2788 14.049 18.0632C13.8347 17.8475 13.7143 17.555 13.7143 17.25C13.7143 16.945 13.8347 16.6525 14.049 16.4368C14.2633 16.2212 14.554 16.1 14.8571 16.1H17.1429C17.446 16.1 17.7367 16.2212 17.951 16.4368C18.1653 16.6525 18.2857 16.945 18.2857 17.25Z"
          fill="#333333"
        />
      </svg>
    );
  }
}

export default CardIcon;